import axiosInstance from '../../../axiosInstance';

// Fetch categories
export const fetchCategories = async () => {
  try {
    const response = await axiosInstance.get(
      // eslint-disable-next-line no-undef
      `${process.env.REACT_APP_SERVER_URL}/api/categories/public`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching categories:', error);
    throw error;
  }
};

// Fetch external roles
export const fetchExternalRoles = async () => {
  try {
    const response = await axiosInstance.get(
      // eslint-disable-next-line no-undef
      `${process.env.REACT_APP_SERVER_URL}/api/roles/by-type/external`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching external roles:', error);
    throw error;
  }
};

// Fetch all external users
export const fetchExternalUsers = async (params = {}) => {
  try {
    const response = await axiosInstance.get(
      // eslint-disable-next-line no-undef
      `${process.env.REACT_APP_SERVER_URL}/api/endUsers`,
      {
        withCredentials: true,
        params: {
          limit: params.limit,
          offset: params.offset,
          sortField: params.sortField,
          sortOrder: params.sortOrder,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching external users:', error);
    throw error;
  }
};

// Fetch single external user by ID
export const fetchExternalUserById = async (id) => {
  try {
    const response = await axiosInstance.get(
      // eslint-disable-next-line no-undef
      `${process.env.REACT_APP_SERVER_URL}/api/endUsers/${id}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching external user:', error);
    throw error;
  }
};

// Create new external user (admin endpoint with temp password)
export const createExternalUser = async (userData) => {
  try {
    const response = await axiosInstance.post(
      // eslint-disable-next-line no-undef
      `${process.env.REACT_APP_SERVER_URL}/api/endUsers/external`,
      userData,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error creating external user:', error);
    throw error;
  }
};

// Update external user
export const updateExternalUser = async (id, userData) => {
  try {
    const response = await axiosInstance.put(
      // eslint-disable-next-line no-undef
      `${process.env.REACT_APP_SERVER_URL}/api/endUsers/${id}`,
      userData,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating external user:', error);
    throw error;
  }
};

// fetch standalone users by category (not assigned to any org)
export const fetchStandaloneUsersByCategory = async (categoryId) => {
  const response = await axiosInstance.get(
    // eslint-disable-next-line no-undef
    `${process.env.REACT_APP_SERVER_URL}/api/endUsers/standalone/${categoryId}`,
    { withCredentials: true }
  );
  return response.data;
};

// Delete external user
export const deleteExternalUser = async (id) => {
  try {
    const response = await axiosInstance.delete(
      // eslint-disable-next-line no-undef
      `${process.env.REACT_APP_SERVER_URL}/api/endUsers/${id}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error deleting external user:', error);
    throw error;
  }
};
